import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { getStats } from 'services/shipments.service'
import { useI18n } from 'i18n'

const StatCard = ({ label, value, tone }) => (
  <div className='rounded-xl border border-slate-200 bg-white p-5'>
    <p className='text-sm text-slate-500'>{label}</p>
    <p className={`mt-1 text-3xl font-bold ${tone || 'text-slate-800'}`}>{value}</p>
  </div>
)

const AdminDashboard = () => {
  const { t } = useI18n()
  const [stats, setStats] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    (async () => {
      try {
        setStats(await getStats())
      } catch (error) {
        toast.error(t('dashboard.loadFailed'))
      } finally {
        setLoading(false)
      }
    })()
  }, [])

  if (loading) return <p className='text-slate-400'>{t('common.loading')}</p>
  if (!stats) return <p className='text-slate-400'>{t('common.noData')}</p>

  return (
    <div className='space-y-6'>
      <div>
        <h1 className='text-2xl font-bold'>{t('adminDashboard.title')}</h1>
        <p className='text-sm text-slate-500'>{t('adminDashboard.subtitle')}</p>
      </div>

      <div className='grid grid-cols-2 gap-4 md:grid-cols-3'>
        <StatCard label={t('adminDashboard.clients')} value={stats.totalClients} />
        <StatCard label={t('adminDashboard.users')} value={stats.totalUsers} />
        <StatCard label={t('adminDashboard.shipments')} value={stats.totalShipments} tone='text-brand' />
      </div>

      <div className='rounded-xl border border-slate-200 bg-white p-5'>
        <h2 className='mb-3 text-sm font-semibold text-slate-700'>{t('adminDashboard.byClient')}</h2>
        <div className='overflow-x-auto'>
          <table className='min-w-full divide-y divide-slate-200 text-sm'>
            <thead className='text-left text-xs uppercase tracking-wide text-slate-500'>
              <tr>
                <th className='px-3 py-2'>{t('adminDashboard.client')}</th>
                <th className='px-3 py-2 text-center'>{t('adminDashboard.shipments')}</th>
                <th className='px-3 py-2 text-center'>{t('adminDashboard.calculated')}</th>
                <th className='px-3 py-2 text-center'>{t('adminDashboard.documents')}</th>
              </tr>
            </thead>
            <tbody className='divide-y divide-slate-100'>
              {(stats.perClient || []).length === 0 && (
                <tr><td colSpan={4} className='px-3 py-6 text-center text-slate-400'>{t('adminDashboard.noClients')}</td></tr>
              )}
              {(stats.perClient || []).map((c) => (
                <tr key={c.client}>
                  <td className='px-3 py-2 font-medium'>{c.client}</td>
                  <td className='px-3 py-2 text-center text-slate-600'>{c.shipments}</td>
                  <td className='px-3 py-2 text-center font-semibold text-status-ready'>{c.calculated}</td>
                  <td className='px-3 py-2 text-center text-slate-600'>{c.documents}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}

export default AdminDashboard
